import classNames from "classnames";

import styles from "./Divider.module.css";

type Props = {
  className?: string;
};

export default function Divider(props: Props) {
  return <hr className={classNames(styles.divider, props.className)} />;
}
